import { render, staticRenderFns } from "./UserDashboardFacilitiesDonor.vue?vue&type=template&id=48b9ca75&scoped=true&"
import script from "./UserDashboardFacilitiesDonor.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilitiesDonor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b9ca75",
  null
  
)

export default component.exports